import { RepairOrderQuoteItems } from '../../../../form-state';
import { useRepairOrderQuotesStore } from '../../../repair-order-quotes-context';
import styles from './styles.module.scss';
import { useGetCommonBrandsQuery } from 'features/vhc/api/use-get-common-brands.query';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
  mainIndex: number;
  rowIndex: number;
};

export const BrandCodeComponent: FC<Props> = ({ mainIndex, rowIndex }) => {
  const { data, isFetching } = useGetCommonBrandsQuery();
  const brandCodes = data?.map((x) => x.code);

  const { isEditMode } = useRepairOrderQuotesStore();
  const {
    watch,
    setValue,
    trigger,
    formState: { errors }
  } = useFormContext<RepairOrderQuoteItems>();

  const brandCode = watch(`items.${mainIndex}.parts.${rowIndex}.brandCode`);
  const isDeleted = watch(`items.${mainIndex}.parts.${rowIndex}.isDeleted`);
  const isLookUped = watch(`items.${mainIndex}.parts.${rowIndex}.isLookUped`);

  const handleChangeBrandCode = (code: string) => {
    if (brandCode == code) return;

    setValue(`items.${mainIndex}.parts.${rowIndex}.brandCode`, code);
    trigger(`items.${mainIndex}.parts.${rowIndex}.brandCode`);
  };

  return (
    <div className={styles.brandCodeContainer}>
      <label className="form-label fs-6 text-nowrap d-none d-md-inline-block">Brand Code</label>
      <select
        disabled={isDeleted || !isEditMode || isFetching || isLookUped}
        className={`form-select form-select-solid ${
          isDeleted || errors?.items?.[mainIndex]?.parts?.[rowIndex]?.brandCode ? 'border-danger' : ''
        }`}
        data-placeholder="Select option"
        data-allow-clear="true"
        data-hide-search="true"
        value={brandCode ?? ''}
        onChange={(e) => handleChangeBrandCode(e.target.value)}
        style={{ ...(isDeleted ? { backgroundColor: '#fff5f8' } : {}) }}
      >
        <option value={''}></option>
        {brandCodes?.map((x) => (
          <option key={x} value={x}>
            {x}
          </option>
        ))}
      </select>
      {errors?.items?.[mainIndex]?.parts?.[rowIndex]?.brandCode?.message && (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">{errors.items[mainIndex]!.parts![rowIndex]!.brandCode?.message ?? ''}</div>
        </div>
      )}
    </div>
  );
};
